import axios from "axios";
import { CommandDetails } from "./CommandDetails";
import qs from "qs";

export class Api {
    private readonly baseUrl: string;
    private readonly params: object;
    private readonly fullUrl: string;

    constructor(commandDetails: CommandDetails) {
        this.baseUrl = commandDetails.baseUrl;
        this.params = commandDetails.payload;
        this.fullUrl = `${this.baseUrl}${qs.stringify(this.params)}`;
    }

    Get = () => axios.get(this.fullUrl).then((response) => {
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        }
    });
}